import { getJSON, v as bvVar } from 'bv';
import { logged_account_number as accountNumber } from 'state';

export default () => (
  getJSON('/api/left_components/favorite_sports_links', {
    c: bvVar('locale'),
    l: accountNumber(),
  })
    .catch(() => [])
);
